import { z } from "zod";

export const bannerSchema = () => {
  return z.object({
    name: z.string().min(1),
    type: z.string().optional(),
    image: z.any().optional(),
    image_mobile: z.any().optional(),
    active: z.boolean(),
    discount: z.number().nullable().optional(),
    exclusive_agreements: z.array(z.number()).optional(),
    exclude_agreements: z.array(z.number()).optional(),
    priority: z.number().optional(),
    url: z.string().url().optional(),
  });
};

export type BannerFormValues = z.infer<ReturnType<typeof bannerSchema>>;
